import React from 'react';
import FieldValueInput from './index';

/**
 * 多字段输入组件
 * @param {Object} props
 *   fields: 字段规则数组 [{key, n, t, ...}]
 *   value: 当前值对象 {key: value}
 *   onChange: (obj) => void
 *   readOnly: 是否只读
 *   nameKey: 用于作为key的字段名
 */
const FieldMultiValueInput = ({ fields = [], value = {}, onChange, readOnly = false, nameKey = 'key' }) => {
    const handleFieldChange = (k, val) => {
        const newValue = { ...value, [k]: val };
        onChange && onChange(newValue);
    };

    return (
        <div>
            {fields.map(rule => (
                < FieldValueInput
                    key={rule[nameKey] || rule.n}
                    rule={rule}
                    field={rule[nameKey] || rule.n}
                    value={value?.[rule[nameKey] || rule.n]}
                    onChange={val => handleFieldChange(rule[nameKey] || rule.n, val)}
                    disabled={readOnly}
                />
            ))}
        </div>
    );
};

export default FieldMultiValueInput; 